import { StoreGet, StoreSet } from "@/types";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function commonActions<T>(set: StoreSet<T>, get: StoreGet<T>) {
  return {
    setter: (arg: ((state: T) => void | T) | Partial<T>) => {
      set(arg);
    },
  };
}
